import {observer} from "mobx-react";
import React from "react";
import {FormProps} from "../../core/form/formUtils";
import {ProjectVersion} from "../domain/project/projectVersionDomain";
import {ClosedFormBlockProps} from "../../core/form/closedForm";
import {DefinitionType} from "../../core/form/form";
import {createForm} from "../../core/form/createForm";
import {ProjectVersionArea} from "../domain/project/projectVersionAreaDomain";
import StyledSelect from "../../core/components/fields/styledSelect";
import {optionsSearch} from "../../core/common/service/commonDataService";
import {AREA_ENTITY} from "../entityConstants";
import {MdTextField} from "../../core/components/fields/fields";
import {Validate} from "../../core/form/validate";


@observer
class ProjectVersionAreaForm extends React.Component<FormProps<ProjectVersionArea, ProjectVersion>, undefined> {

  render(): JSX.Element | false | null {
    let {dataObject, rootObject, entities, entity} = this.props;
    let fields = dataObject.getFormFields(ProjectVersionAreaFormDefinition.formName);
    let {area, m2, note} = fields;


    return (
      <div>
        <div className="row">
          <div className="fx col-xs-4 col-sm-4">
            <StyledSelect {...area.props} async={true} clearable asterixForAll loadOptions={optionsSearch.bind(this, AREA_ENTITY, {})}/>
            <Validate field={area} value={area.props.value}/>
          </div>
          <div className="fx col-xs-4 col-sm-4">
            <MdTextField {...m2.props}/>
            <Validate field={m2} value={m2.props.value}/>
          </div>
          <div className="fx col-xs-4 col-sm-4">
            <MdTextField {...note.props}/>
            <Validate field={note} value={note.props.value}/>
          </div>
        </div>
      </div>
    );
  }
}

const ClosedContent = ({dataObject, entity, entities, fields, disabled}: ClosedFormBlockProps<ProjectVersionArea>) => (
  <div style={{width: '100%'}}/>
);

export const ProjectVersionAreaFormDefinition: DefinitionType = {
  formName: 'ProjectVersionAreaForm',
  fields: [
    {name : 'area', validators : ['IsRequired']},
    {name : 'm2', validators: ['IsRequired', 'IsNumber', {validation: 'Min', parameters: {min: 0}}]},
    {name : 'note'}
  ]
};

export default createForm(ProjectVersionAreaFormDefinition, ClosedContent)(ProjectVersionAreaForm);



// WEBPACK FOOTER //
// ./src/sbtool/component/projectVersionAreaForm.tsx